module.exports = process.env.NODE_ENV === 'production' ?
  require('./Root.prod') : require('./Root.dev');



// WEBPACK FOOTER //
// ./src/containers/Root.jsx